import { Component, Input } from '@angular/core';

/** Specchietto informativo agenzia (`.container-logoadv`): header o collapse del menu (tenant `menuConfiguration.mobileInfoVisible`). */
@Component({
  selector: 'app-agency-info',
  styleUrls: ['./agency-info.component.scss'],
  templateUrl: './agency-info.component.html'
})
export class AgencyInfoComponent {

  @Input() public iter: any;
  @Input() public lastUpdate: any;
  @Input() public logoAdv: any;
  @Input() public consolidator: any;
  @Input() public isTravelAgency: any;
  /** Id DOM del contenitore: solo l'istanza nell'header lo valorizza, per non duplicarlo. */
  @Input() public containerId: string | null = null;

  public sanitizeTelephoneForLink(telephone: string): string {
    return telephone ? telephone.replace(/[^\d+]/g, '') : '';
  }

}
